import Validator from "./Validator";

export default class JsonEntitiesEntityDataCardContentRowsRowComponentsComponentDataSeriesItemPointStartValidator extends Validator {
    constructor() {
        super();
        this.validationRules = {
            type: 'number',
            empty: false,
            mandatory: false
        };
    }
}
